import React from "react";
import ResponsiveImage from "./ResponsiveImage";
import { IconCheck } from "./Icons";

export const About = ({ data }) => {
  const why = [...(data?.Why || []), ...(data?.Why2 || [])];

  return (
    <section className="section" id="about">
      <div className="container">
        <div className="about">
          <div className="about__media">
            <ResponsiveImage
              src="/img/about.jpg"
              alt="The Mandara and Guida family home in Positano"
              sizes="(max-width: 1024px) 100vw, 520px"
            />
            <div className="about__badge">
              <strong>Built by Nonno Gaetano</strong>
              Owned and hosted by the Mandara and Guida families
            </div>
          </div>

          <div className="about__text">
            <div className="section-head section-head--left">
              <span className="eyebrow">Our story</span>
              <h2>About us</h2>
              <hr className="rule" />
            </div>

            <p>{data?.paragraph}</p>

            <ul className="about__list">
              {why.map((item) => (
                <li key={item}>
                  <IconCheck width={16} height={16} />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
